module.exports = {
    getUrl: Odigeo._.constant('enableautorenewal'),

    getMethod: Odigeo._.constant('PUT'),

    requestSuccess: function() {
        Odigeo.trigger(this.widget.id + ':enableAutoRenewalOk');
    },

    requestError: Odigeo._.noop(),
};
